import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom';
import { logout } from '../actions/userAction';

function Logout() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const guestCrm = JSON.parse(localStorage.getItem("guestCrm"));

    useEffect(() => {
        dispatch(logout())
        navigate('/')
    }, [])

}

export default Logout